import { MeiliSearch } from "meilisearch";
import { instantMeiliSearch } from "@meilisearch/instant-meilisearch";
import { meilisearchAutocompleteClient } from "@meilisearch/autocomplete-client";
import { PRIMARY_KEY } from "@cappelendamm/catalogue/constants";

export const indexClient = new MeiliSearch({
  host: "https://edge.meilisearch.com",
  apiKey: process.env.MEILISEARCH_MASTER_KEY,
});

export const { searchClient } = instantMeiliSearch(
  "https://edge.meilisearch.com",
  process.env.NEXT_PUBLIC_MEILISEARCH_NETTHANDEL_SEARCH_KEY,
);

export const autocompleteClient = meilisearchAutocompleteClient({
  url: "https://edge.meilisearch.com",
  apiKey: process.env.NEXT_PUBLIC_MEILISEARCH_NETTHANDEL_SEARCH_KEY,
  options: {
    primaryKey: PRIMARY_KEY,
  },
});
